import type { AnyFSA } from '@makemydeal/dr-browser-utils';
import type { StateTree } from '@makemydeal/dr-dash-types';
import { actionCreators } from '@makemydeal/dr-offer-redux';
import { type ReduxNext, type ReduxStore, initActionTypes } from '@makemydeal/dr-shared-store';

import {
    getCurrentOfferType,
    getTaxItemsWithOverridesWithoutFlat,
    isTaxCapped,
    getCapReductionTaxCapitalizedIndicator
} from '../selectors/offerRedux';
import { categorizeTaxes } from '../utils/taxUtils';
import { PAYMENT_RECEIVED } from '../actionTypes/deskingActionTypes';

export const middleware = (store: ReduxStore<StateTree>) => (next: ReduxNext) => (action: AnyFSA) => {
    next(action);

    switch (action.type) {
        case initActionTypes.INIT_SUCCESS:
        case PAYMENT_RECEIVED: {
            const state = store.getState();
            const offerType = getCurrentOfferType(state);
            const taxItems = getTaxItemsWithOverridesWithoutFlat(state, offerType);

            if (!taxItems || taxItems.length === 0) {
                break;
            }

            const isTaxCappedValue = isTaxCapped(state);
            const isCrtCapped = getCapReductionTaxCapitalizedIndicator(state);

            const { capitalizedTaxes, upfrontTaxes } = categorizeTaxes(taxItems, {
                isTaxCapped: isTaxCappedValue,
                isCrtCapped
            });

            const taxesWithCapitalize = [...capitalizedTaxes, ...upfrontTaxes];

            if (taxesWithCapitalize.length > 0) {
                store.dispatch(actionCreators.updateTaxItems(taxesWithCapitalize, offerType, false));
            }

            break;
        }

        default:
            break;
    }
};
